module.exports = __webpack_public_path__ + "static/media/project_1.d9ec0f75.md";